module.exports = __webpack_public_path__ + "static/media/style transfer2.3d993e50.gif";